import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Chart from '@components/overview-dashboard/common/chart/Chart';
import { setSelectedKPI } from '@store/overviewDashboard/base/actions';
import { kpiMetricSelector } from '@store/overviewDashboard/base/selectors';
import {
  MetricCard, Metric, MetricTotal, MetricNumber, MetricUnit, MetricLabel,
} from './styled';

const AudienceMetricWidget = ({ metricData }) => {
  const dispatch = useDispatch();
  const selectedMetric = useSelector(kpiMetricSelector);

  const renderMetricTitle = () => (
    <Metric>
      <MetricTotal>
        <MetricNumber>
          {metricData.humanizedNumber}
        </MetricNumber>
        <MetricUnit>
          {metricData.humanizedUnit}
        </MetricUnit>
      </MetricTotal>
      <MetricLabel>
        {metricData.displayName}
      </MetricLabel>
    </Metric>
  );

  const renderChart = () => {
    const height = '70px';
    const width = '100%';

    if (metricData) {
      return <Chart option={metricData.chartData} height={height} width={width} />;
    }
  };

  const isSelectedForDimensionTable = () => selectedMetric === metricData.metricKey;

  const setDimension = () => {
    if (isSelectedForDimensionTable()) {
      dispatch(setSelectedKPI('StreamingPerformanceIndex'));
    } else {
      dispatch(setSelectedKPI(metricData.metricKey));
    }
  };

  return (
    <div id={metricData.metricKey} className={isSelectedForDimensionTable() ? 'active' : ''}>
      <MetricCard selected={isSelectedForDimensionTable()} onClick={setDimension}>
        {renderMetricTitle()}
        {renderChart()}
      </MetricCard>
    </div>

  );
};

export default AudienceMetricWidget;
